<span class="status-label"> {{ getStatusString(item) }} </span>